import React, { useState, useEffect } from "react";
import {
  getCompany,
  getDocumentRequest,
  getInternStudent,
  getInternshipRequest,
  getDocumentReqStudent,
} from "../../api/crud";
import _ from "lodash";
import DocRequest from "../../Components/task/DocRequest";
import DocumentCompleted from "../../Components/task/DocumentCompleted";
import TaskStatusCard from "../../Elements/TaskStatusCard";

const Task = () => {
  const [documentManage, setDocumentManage] = useState([]);
  const [documentCreate, setDocumentCreate] = useState([]);

  const getData = async () => {
    const documentRequest = await getDocumentRequest();
    const internStudent = await getInternStudent();
    const allCompany = await getCompany();
    const internshipRequest = await getInternshipRequest();
    const documentReqStudent = await getDocumentReqStudent();

    const group = _.groupBy(documentReqStudent, (ev) => ev.idm_id);

    const docreqTest = documentRequest.map((item) => {
      return {
        ...item,
        internStd: group[item.idm_doc_id],
      };
    });

    const mapDocreqTest = docreqTest.map((item) => {
      return {
        ...item,
        companyDetail: allCompany.find((el) => el.id === item.cp_id),
        internStd: item.internStd.map((el) => {
          return {
            ...el,
            internStudent: internStudent.find((st) => st.id === el.st_id),
            internshipRequest: internshipRequest.find(
              (st) => st.st_id === el.st_id
            ),
          };
        }),
      };
    });

    setDocumentManage(mapDocreqTest);

    const filterStudent = internStudent.filter((st) => st.status_id === 12);

    const studentDetail = filterStudent.map((st) => {
      const find = internshipRequest.find((el) => el.st_id === st.id);

      return {
        ...st,
        internDetail: find,
      };
    });

    const companyWithStd = allCompany
      .map((company) => {
        const internSt = studentDetail.filter(
          (st) => st.internDetail?.cp_id === company.id
        );

        return {
          ...company,
          internStudent: internSt,
        };
      })
      .filter((item) => item.internStudent.length);

    setDocumentCreate(companyWithStd);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <main className="content">
      <div className="container-fluid p-0">
        <h1 className="h3 mb-3">Tasks</h1>

        <div className="d-flex gap-2">
          <TaskStatusCard
            cardWidth="300px"
            title="สร้างหนังสือขอความอนุเคราะห์"
            data={documentCreate.length}
          />
          <TaskStatusCard
            cardWidth="300px"
            title="เตรียมออกหนังสือ"
            data={documentManage.filter((el) => el.idm_status === "1").length}
          />
          <TaskStatusCard
            cardWidth="300px"
            title="ออกหนังสือแล้ว"
            data={documentManage.filter((el) => el.idm_status === "2").length}
          />
          <TaskStatusCard
            cardWidth="300px"
            title="นิสิตรับหนังสือแล้ว"
            data={documentManage.filter((el) => el.idm_status === "3").length}
          />
          <TaskStatusCard
            cardWidth="300px"
            title="หนังสือที่ยกเลิก"
            data={documentManage.filter((el) => el.idm_status === "0").length}
          />
        </div>

        <div className="row">
          <div className="col-12 col-lg-6 ">
            <DocumentCompleted />
          </div>
          <div className="col-12 col-lg-6">
            <DocRequest />
          </div>
        </div>
      </div>
    </main>
  );
};

export default Task;
